







import { Component, Vue } from 'vue-property-decorator';
import { Imprint as Imp } from 'imprint-lib';
import { Market } from '@avp/context-claims';
import { fetchHTML } from '@/services/imprint';

@Component({ components: {} })
export default class Imprint extends Vue {
  private htmlSnippet = '';

  private imprint = new Imp(undefined, undefined, undefined, 'en-EN');
  private language = 'en-EN';

  private async mounted(): Promise<void> {
    try {
      const response = await this.$digitalGiveawayClient.getOrder(this.$route.params.id);
      if (response.market === Market.DEU) {
        this.language = 'de-DE';
      }
    } catch (error) {
      console.log('Could not determine market. Displaying english imprint.');
    }
    const url = this.imprint.path(this.language);
    this.htmlSnippet = await fetchHTML(url);
  }
}
